import { jsonldReviewName } from './JsonldStore';

export const updateJsonldReviewName = (value) => jsonldReviewName.update((oldValue) => value);
